import { render, staticRenderFns } from "./ZiraatBankForm.vue?vue&type=template&id=37b4596b"
import script from "./ZiraatBankForm.vue?vue&type=script&lang=js"
export * from "./ZiraatBankForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports